export default __webpack_public_path__ + "static/media/1928.22398d39.png";